export default "__VITE_ASSET__B7Nx1l7O__"